export class AnalyticsClient {
  private baseUrl: string;
  private failedRequests: number = 0;
  private readonly MAX_FAILURES = 3;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async send(event: { 
    event_type: string; 
    page?: string; 
    session_id?: string; 
    duration_sec?: number; 
    payload?: any 
  }): Promise<void> {
    // Circuit breaker: stop sending if too many failures
    if (this.failedRequests >= this.MAX_FAILURES) {
      console.warn('📊 Analytics: Too many failures, skipping event');
      return;
    }

    try {
      const response = await fetch(`${this.baseUrl}/api/analytics/events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(event),
      });

      if (!response.ok) {
        throw new Error(`Analytics failed: ${response.status}`);
      }

      // Reset failure count on success
      this.failedRequests = 0;
    } catch (error) {
      this.failedRequests++;
      
      // Log error but don't throw - analytics should never crash the app
      console.error('📊 Analytics error (failure #' + this.failedRequests + '):', error);
      
      // Don't re-throw - silently fail analytics
      // This prevents the error from bubbling up and causing re-renders
    }
  }
}